import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-invoice",
  templateUrl: "./invoice.component.html",
  styleUrls: ["./invoice.component.scss"],
})
export class InvoiceComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<InvoiceComponent>) {}
  invoice = {
    membershipCode: "1",
    accessCode: "1",
    customerName: "عميل إختبار",
    phone: "0111111119",
    plan: "خطة تجريبية",
    salesEmployee: "testusernewui",
    trainer: "",
    paymentDate: "12-02-2026 17:08:56",
    startDate: "Feb 12, 2026",
    endDate: "Feb 15, 2026",
    totalRequired: 1000,
    paidCash: 500,
    paidCard: 200,
    paidTransfer: 200,
    totalPaid: 900,
    remaining: 100,
    discount: 0,
    notes: "",
    benefits: [
      { name: "Freeze", count: 1 },
      { name: "Massage", count: 1 },
      { name: "Inbody", count: 1 },
      { name: "Meditation", count: 1 },
      { name: "Cupping", count: 1 },
      { name: "Invitations", count: 1 },
      { name: "PTSessions", count: 1 },
      { name: "Fitness", count: 1 },
      { name: "Nutrations", count: 1 },
      { name: "FreeDays", count: 1 },
    ],
  };

  ngOnInit(): void {
    setTimeout(() => {
      this.printInvoice();
    }, 500);
  }

  printInvoice() {
    const printContents =
      document.getElementById("invoice-print-area")?.innerHTML;
    if (printContents) {
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;

      // اقفل الـ Dialog بعد الطباعة
      this.dialogRef.close();
    }
  }
}
